import {Vue} from "vue-property-decorator";

/**
 * @deprecated
 */
export default {
    Tokens: {
        BearerToken: Vue.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)),
        RefreshToken: Vue.$cookies.get(String(process.env.VUE_APP_COOKIE_REFRESH_TOKEN)),
    },
    UserName: Vue.$cookies.get(String(process.env.VUE_APP_COOKIE_COGNITO_USER_NAME)),
    AccountId: Vue.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID)),
}